import React from "react";
import { FiEye } from "react-icons/fi";

/**
 * "Priya S is viewing this ticket" — collision detection above the thread.
 *
 * Renders nothing when nobody else is on the ticket, which is the common case,
 * so it costs no vertical space until it matters.
 *
 * @param {Object} props
 * @param {Array<{ userId: string, name: string|null }>} props.viewers - Other
 *   agents currently on this ticket (never the viewer themselves).
 */
export function ViewingStrip({ viewers }) {
  if (!viewers || viewers.length === 0) return null;

  const names = viewers.map((v) => v.name || "Another agent");
  const label =
    names.length === 1
      ? `${names[0]} is viewing this ticket`
      : `${names.slice(0, 2).join(", ")}${
          names.length > 2 ? ` +${names.length - 2}` : ""
        } are viewing this ticket`;

  return (
    <p
      role="status"
      className="flex items-center gap-1.5 border-b border-internal/30 bg-internal-bg px-4 py-1.5 text-[11px] text-internal-text"
    >
      <FiEye aria-hidden="true" size={12} className="shrink-0" />
      {label}
    </p>
  );
}

export default ViewingStrip;
